import { useState, useReducer, useEffect } from 'react'
import { fetchListReducer, actionType } from 'reducers/fetchList'


export const useFetchList = (service, initialQuery, initialDataList) => {
  const [query, setQuery] = useState(initialQuery)

  const [state, dispatch] = useReducer(fetchListReducer, {
    isLoading: false,
    isError: false,
    dataList: initialDataList,
  })
  
  useEffect(() => {
    if (window?.navigator.onLine !== false) {
      let didCancel = false
      const fetchData = async () => {
        dispatch({ type: actionType.FETCH_INIT })
        const response = await service(query)
        if (!didCancel) {
          if (!response.error) {
            dispatch({ type: actionType.FETCH_SUCCESS, payload: response })
          } else {
            dispatch({ type: actionType.FETCH_FAILURE })
          }
        }
      }
      fetchData()
      return () => {
        didCancel = true
      }
    }
  }, [query])
 
  return [state, setQuery]
}